import { AbstractCreativeModel } from './Creative'

export class BannerModel extends AbstractCreativeModel {
  constructor(data = {}) {
    super()
    const {
      id,
      anCreativeId,
      name,
      status,
      isExpired,
      creativeFolderId,
      width,
      height,
      landingPageUrl,
      imageUrl,
      anAuditStatus,
      anAuditFeedback,
      anGoogleStatus,
      anGoogleFeedback,
    } = data
    this.id = id
    this.anCreativeId = anCreativeId
    this.name = name
    this.status = status
    this.isExpired = isExpired
    this.creativeFolderId = creativeFolderId
    this.width = width
    this.height = height
    this.landingPageUrl = landingPageUrl
    this.imageUrl = imageUrl
    this.anAuditStatus = anAuditStatus
    this.anAuditFeedback = anAuditFeedback
    this.anGoogleStatus = anGoogleStatus
    this.anGoogleFeedback = anGoogleFeedback
  }

  static assign(data) {
    return new BannerModel(data)
  }

  static get maxSize() {
    return 40 * 1024 // 40kb
  }

  /**
   * Pingファイルの圧縮率がおよそ75%ほどのため maxSize() 以下にするのは maxSize()*4 まで。
   * 余裕を持たせて -10KB に設定している
   */
  static get maxPingSize() {
    return 150 * 1024 // 150kb
  }
}
